import flow from 'lodash/flow';
import globalStore from '@/app/store';

/**
 * Injects `initialize()` (param initialize) call into component() section for each config section
 * @param initialize Function
 * @param config ModuleConfig
 * @return ModuleConfig
 */
export function initializeModule(initialize, config) {
  const f = item => Object.assign({}, item, { component: flow([initialize, item.component]) });

  return Object.keys(config).reduce((result, key) => {
    result[key] = f(config[key]);
    return result;
  }, {});
}

/**
 * @param moduleStore
 */
export function registerStoreModule(moduleStore) {
  if (!globalStore.state[moduleStore.state.moduleName]) {
    globalStore.registerModule(moduleStore.state.moduleName, moduleStore);
  }
}

export function getUrlParameter(paramName) {
  let value;
  if (typeof window !== 'undefined' && window.location !== 'undefined') {
    const uriParts = window.location.href.split('?');
    if (uriParts.length > 1) {
      const lwCaseParamName = paramName.toLowerCase();
      const queryParams = uriParts[1].split('/')[0].split('&');
      for (let i = 0; i < queryParams.length; i++) {
        const pair = queryParams[i].split('=');
        if (pair[0].toLowerCase() === lwCaseParamName) {
          [, value] = pair;
        }
      }
    }
  }
  return value;
}
